import React, { useState } from 'react';
import { View, Pressable, Text } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/pro-regular-svg-icons';

import { FieldLabel, StyledTextInput } from 'app/src/elements/inputs';
import Modal from 'app/src/elements/Modal';
import { Button, ButtonGroup } from 'app/src/elements/buttons';

import { currency } from './index';

export const Counter = props => {
  const {
    saleAsset, setShowModal, updateOffer, buyer, setShowSaleHistory
  } = props;

  const [counterPrice, setCounterPrice] = useState('');
  const [counterNote, setCounterNote] = useState('');

  const saveCounter = () => {
    if (buyer) {
      updateOffer({
        result: 'Buyer Countered',
        buyerPrice: counterPrice,
        buyerCounterNote: counterNote,
      });
    } else {
      updateOffer({ counterPrice, counterNote });
    }
  };

  const label = buyer ? 'Buyer Counter' : 'Counter Offer';

  return (
    <Modal
      showModal
      setShowModal={setShowModal}
      modalType={saleAsset.lotNumber}
      objectName={saleAsset.asset.name}
    >
      <View style={{flexDirection: 'row', gap: 10, marginBottom: 10}}>
        {buyer ? (
          <Text>
            Seller Counter: {currency(saleAsset.activeOffer.counterPrice)}
          </Text>
        ) : (
          <Text>
            Latest Bid: {currency(saleAsset.activeOffer.price)}
          </Text>
        )}
        <Pressable
          onPress={() => setShowSaleHistory(saleAsset)}
          style={{display: 'inline-block'}}
        >
          <FontAwesomeIcon
            icon={faClockRotateLeft}
            title="View Bid History"
          />
        </Pressable>
      </View>
      <FieldLabel label={label} />
      <StyledTextInput
        onChange={e => setCounterPrice(e.target.value)}
        value={counterPrice || ''}
      />
      <br />
      <FieldLabel label="Note (optional)" />
      <StyledTextInput
        onChange={e => setCounterNote(e.target.value)}
        value={counterNote || ''}
      />
      <ButtonGroup>
        <Button label="Update" onPress={saveCounter} />
      </ButtonGroup>
    </Modal>
  );
};

export default Counter;
